import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import InlineText from '@/design_system/Typography/InlineText';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconStoreDeposit from '@/icons/StoreDeposit.svg';
import { RequestWithRelations } from '@/models/request';
import { formatDate } from '@/utils/date';

export const DepositMessage = ({ request }: { request: RequestWithRelations }) => {
  const storeName = (
    <InlineText size="200" weight="bold">
      {request.store?.name}
    </InlineText>
  );
  const createdAt = request.articles[0]?.createdAt;
  const createdAtDate = createdAt ? (
    <InlineText size="200" weight="bold">
      {formatDate(new Date(createdAt), { dateStyle: 'medium' })}
    </InlineText>
  ) : null;

  if (!createdAtDate) {
    return null;
  }

  return (
    <Stack row flexWrap="initial" gap="0.25rem" className="text-secondary">
      <IconStoreDeposit style={{ fontSize: '1rem' }} />
      <Paragraph size="200">
        <Trans id="client.articles.deposited-on">
          Your items have been deposited on {createdAtDate} in the {storeName} store.
        </Trans>
      </Paragraph>
    </Stack>
  );
};
